import React from "react";
import { FiCalendar } from "react-icons/fi";
import { Col } from "reactstrap";

const Widget = ({ today }) => {
  return (
    <div>
      <div className="todayWeather d-flex   align-items-baseline justify-content-center gap-2">
        <i className="  pb-2 text-white  bg-red-opacity   px-2  rounded-3 ">
          <FiCalendar />
        </i>

        <p style={{ fontSize: "14px" }}>{today}</p>
      </div>
      {/* <div className="d-flex align-items-center justify-content-center text-center my-2 homeWeather"> */}
      {/* <Col className="direction-ltr p-0">
                    <p className="m-0 fn">28° C</p>
                    <small className="fn10">داخل سالن</small>
                </Col>
                <Col className="direction-ltr p-0">
                    <p className="m-0 fn">122</p>
                    <small className="fn10">رطوبت</small>
                </Col>
                <Col className="direction-ltr p-0">
                    <p className="m-0 fn">28° C</p>
                    <small className="fn10">دمای منزل</small>
                </Col>
                <Col className="direction-ltr p-0">
                    <p className="m-0 fn">12° C</p>
                    <small className="fn10">تهران</small>
                </Col> */}
      {/* </div> */}
    </div>
  );
};

export { Widget };
